// Connection state of the SignalR notification channel, for the nav bar indicator.
// 'connected' | 'connecting' | 'reconnecting' | 'disconnected'
const initState = () => ({
  connectionState: 'disconnected',
})

export const state = initState

export const getters = {
  isSignalRConnected: (state) => state.connectionState === 'connected',
  signalRConnectionState: (state) => state.connectionState,
}

export const mutations = {
  setConnectionState(state, {connectionState}) {
    state.connectionState = connectionState;
  },
}
